module.exports = __webpack_public_path__ + "static/img/ailu.571fb23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/ailu.png
// module id = Lxyd
// module chunks = 1